import { Navigate, Outlet } from 'react-router';
import { useAuth } from '../stores/AuthContext';

const PrivateRoute = () => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/auth" replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;
